import { LitElement, classMap, css, html, nothing } from '@lit'
import { checkIsTouchDevice } from '@nova/utils'

class NovaProductCardQuickShop extends LitElement {
  static properties = {
    productOptions: {
      type: Array,
      attribute: 'product-options',
      converter: (value) => value.split(','),
    },
    variants: { type: Array },
    activeVariant: {
      type: Number,
      attribute: 'active-variant',
    },
  }

  get isTouchDevice() {
    return checkIsTouchDevice()
  }

  get optionsToShow() {
    return this.productOptions.filter((option) =>
      this.variants.find((variant) => variant.options.includes(option)),
    )
  }

  findVariantByOption(option) {
    return this.variants.find((variant) => variant.options.includes(option))
  }

  setActiveVariant(variant) {
    this.activeVariant = variant
  }

  handleOptionClick(event) {
    const { option, variantId } = event.target.dataset

    this.activeOption = option
    const activeVariant = this.variants.find(
      (variant) => variant.id === Number.parseInt(variantId),
    )

    this.setActiveVariant(activeVariant)

    this.dispatchEvent(
      new CustomEvent('option-selected', {
        bubbles: true,
        composed: true,
        detail: {
          variant: activeVariant,
        },
      }),
    )
  }

  render() {
    if (this.isTouchDevice) return nothing
    return html`
      <div class="quick-shop__option_selector">
        ${this.optionsToShow.map((option, i) => {
          const variant = this.findVariantByOption(option)
          const stateClasses = {
            'quick-shop__option': true,
            'quick-shop__option--sold-out': !variant?.available,
            'quick-shop__option--selected':
              variant.id === this.activeVariant?.id,
          }

          return html`
            <sl-button
              class="${classMap(stateClasses)}"
              data-variant-id=${variant?.id}
              data-option=${option}
              aria-label="option: ${option}"
              variant="text"
              size="small"
              ?disabled=${variant.available === false}
              @click=${this.handleOptionClick}>
              ${option}
            </sl-button>
          `
        })}
      </div>
    `
  }

  static styles = css`
    .quick-shop__option_selector {
      width: 100%;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: white;
    }

    .quick-shop__option {
      display: flex;
      align-items: center;
    }

    .quick-shop__option::part(base) {
      border-color: transparent;
      width: fit-content;
      min-height: auto;
      padding: 0;
      border-radius: 0;
    }

    .quick-shop__option::part(base):hover {
      color: var(--nova-brand-ink);
      border-bottom: 1px solid black;
    }

    .quick-shop__option::part(label) {
      padding: 0 var(--nova-space-2xs);
      font: var(--nova-h6-font);
      color: var(--nova-brand-subdued);
      line-height: 20px;
      font-weight: bold;
      text-transform: uppercase;
    }

    .quick-shop__option--selected::part(base) {
      border-bottom: 1px solid var(--nova-brand-primary) !important;
    }

    .quick-shop__option--selected::part(label) {
      color: var(--nova-brand-ink);
    }


    .quick-shop__option--sold-out + .quick-shop__option--sold-out {
      margin-left: 5px;
    }

    .quick-shop__option--sold-out {
      text-decoration: line-through;
      color: var(--nova-brand-subdued);
    }
  `
}

customElements.define('nova-product-card-quick-shop', NovaProductCardQuickShop)
